export default function initializeAutopilot (userEmail) {
  if (!window.Autopilot) return;
  
  window.Autopilot.run("associate", {
    Email: userEmail,
  });
};